<template>
  <div class="list-all-articles-header" style="color: #ffffff;">
    <h2 class="heading-lg text-white">Articles</h2>
    <h4 class="heading-xs text-white">Understanding your sleep health, sleep apnea</h4>
  </div>
</template>

<script>
export default {
  name: "articleBlogsHeader",
};
</script>

<style lang="scss" scoped>
.list-all-articles-header {
  height: 260px;
  background: url("../../assets/images/sleep-apnea-product-manuals-purple-concentric-circles-bkg.png")
    center no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-align: center;

  h2 {
    font-size: clamp(31px, 52px, 60px);
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 400;
    margin: 0;

    @media (max-width: 767px) {
      font-size: 31px;
    }
  }

  h4 {
    font-size: clamp(16px, 24px, 29px);
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 400;
    padding: 0 32px;

    @media (max-width: 767px) {
      font-size: 18px;
    }
  }
}
</style>
